// extracted by mini-css-extract-plugin
module.exports = {"h1w8168s":"h1w8168s","bui2te1":"bui2te1"};